// extracted by mini-css-extract-plugin
module.exports = {"container":"Sentence_container__1_8b5"};